import { ISelectItem } from "shared/ui/Select/types";

export const selectValues: ISelectItem[] = [
  {
    id: 1,
    title: "Мужской",
  },
  {
    id: 2,
    title: "Женский",
  },
];
